<div class="region_data m-0">
  <div class="col-md-12 formborder">
    <button
      class="mt-3 btn font-size-12 button-btn"
      (click)="onAddRegion()"
    >
      <i
        class="fa fa-plus mr-1"
        style="font-size: medium; cursor: pointer"
      ></i>
      Add Region
    </button>
    <button
      class="mt-3 btn font-size-12 button-btn ml-2"
      (click)="exportexcelNew()"
    >
      <i
        class="fa fa-file-export mr-1"
        style="font-size: medium; cursor: pointer"
      ></i>
      Export
    </button>
  </div>

  <div class="col-md-12 p-1">
    <app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
    <div class="table-responsive mt-1">
      <mat-table
        [dataSource]="dataSource"
        matSort
        style="overflow: auto; max-width: 100%; height: 60vh"
      >
        <ng-container matColumnDef="StateId">
          <mat-header-cell
            mat-sort-header
            class="grid-header"
            style="max-width: 50px"
            *matHeaderCellDef
          >
            #
          </mat-header-cell>
          <mat-cell
            *matCellDef="let region_data; let i = index"
            class="grid-cell"
            style="max-width: 50px"
          >
            {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Region_Name">
          <mat-header-cell
            mat-sort-header
            class="grid-header"
            style="max-width: 250px"
            *matHeaderCellDef
          >
            Region
          </mat-header-cell>
          <mat-cell
            *matCellDef="let region_data"
            class="grid-cell"
            style="max-width: 250px"
          >
            {{ region_data.Region_Name }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Region_Code">
          <mat-header-cell
            mat-sort-header
            class="grid-header"
            *matHeaderCellDef
          >
            Region Code
          </mat-header-cell>
          <mat-cell *matCellDef="let region_data" class="grid-cell">
            {{ region_data.Region_Code }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="State_Name">
          <mat-header-cell
            mat-sort-header
            class="grid-header"
            *matHeaderCellDef
          >
            State
          </mat-header-cell>
          <mat-cell *matCellDef="let region_data" class="grid-cell">
            {{ region_data.State_Name }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Cluster_Count">
          <mat-header-cell
            mat-sort-header
            class="grid-header"
            *matHeaderCellDef
          >
            Cluster Count
          </mat-header-cell>
          <mat-cell *matCellDef="let region_data" class="grid-cell">
            {{ region_data.Cluster_Count }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Action">
          <mat-header-cell
            class="grid-header j-c-center"
            *matHeaderCellDef
          >
            Action
          </mat-header-cell>
          <mat-cell *matCellDef="let region_data" class="grid-cell j-c-center">
            <i
              class="fas fa-lg fa-edit margin-right-4xs cursor-style"
              aria-label="true"
              (click)="onEditRegion(region_data)"
            ></i>
          </mat-cell>
        </ng-container>
        <!-- Fix: correct mat-header-row and mat-row syntax -->
        <mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></mat-header-row>
        <mat-row *matRowDef="let region_data; columns: displayedColumns"></mat-row>
      </mat-table>
      <mat-paginator
        #paginatorRef
        [pageSizeOptions]="[20, 50]"
        showFirstLastButtons
      >
      </mat-paginator>
    </div>
  </div>
</div>

<div class="modal fade in" id="EditRegionModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
<div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 450px;">
  <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
    <div cdkDragHandle class="modal-header" style="padding: 8px 12px;">
      <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
        {{ editRegionObj.RegionId ? "Edit Region" : "Add Region" }}
      </h6>
      <button type="button" (click)="onCloseModal()" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true"><i class="far text-black fa-times-circle"></i></span>
      </button>
    </div>
    <div class="modal-body" style="padding: 12px;">
      <form #f="ngForm">
        <div class="row m-0">
          <div class="col-md-12 p-1">
            <span class="required-lable">Region</span>
            <input
              type="text"
              name="Region_Name"
              [(ngModel)]="editRegionObj.Region_Name"
              class="form-control input-text-css"
            />
          </div>
          <div class="col-md-12 p-1">
            <span class="required-lable">Region Code</span>
            <input
              type="text"
              name="Region_Code"
              [(ngModel)]="editRegionObj.Region_Code"
              class="form-control input-text-css"
            />
          </div>
          <div class="col-md-12 p-1">
            <span class="required-lable">State</span>
            <select
              name="StateId"
              [(ngModel)]="selectedStateId"
              class="form-control input-text-css"
            >
              <option value="">-- Select State --</option>
              <option
                *ngFor="let state of StateListDropdown"
                [value]="state.StateId"
              >
                {{ state.State_Name }}
              </option>
            </select>
          </div>
          <div class="col-md-12 text-center mt-2 mb-1">
            <button
              type="button"
              (click)="onSaveRegion()"
              class="btn font-size-12 button-btn"
            >
              Save
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
</div>

<table
  id="Region_List"
  class="table table-bordered bg-white"
  style="font-family: 'Times New Roman', Times, serif; display: none"
>
  <tr>
    <th style="background: #4dc3a3 !important; border: 1px solid white">#</th>
    <th style="background: #4dc3a3 !important; border: 1px solid white">
      Region
    </th>
    <th style="background: #4dc3a3 !important; border: 1px solid white">
      Region Code
    </th>
    <th style="background: #4dc3a3 !important; border: 1px solid white">
      State
    </th>
    <th style="background: #4dc3a3 !important; border: 1px solid white">
      Cluster Count
    </th>
  </tr>

  <tr *ngFor="let x of JsonData; let i = index">
    <td>{{ i + 1 }}</td>
    <td>{{ x.Region_Name }}</td>
    <td>{{ x.Region_Code }}</td>
    <td>{{ x.State_Name }}</td>
    <td>{{ x.Cluster_Count }}</td>
  </tr>
</table>
